import { ManageShippingAddressesCTA } from "./ctas";
export var ShippingAddressIA = function ShippingAddressIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return MANAGE_SHIPPING_ADDRESSES(strictLocalize);
    },
    getDescription: function getDescription() {
      return [YOU_ARE_ABLE_TO_MANAGER_YOUR_SHIPPING_ADDRESSES(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return ManageShippingAddressesCTA(strictLocalize);
};
var MANAGE_SHIPPING_ADDRESSES = function MANAGE_SHIPPING_ADDRESSES(strictLocalize) {
  return strictLocalize({
    id: "qs+/Mw",
    defaultMessage: [{
      "type": 0,
      "value": "Manage shipping addresses"
    }]
  });
};
var YOU_ARE_ABLE_TO_MANAGER_YOUR_SHIPPING_ADDRESSES = function YOU_ARE_ABLE_TO_MANAGER_YOUR_SHIPPING_ADDRESSES(strictLocalize) {
  return strictLocalize({
    id: "OyceDQ",
    defaultMessage: [{
      "type": 0,
      "value": "You can manage your shipping addresses through your Shipping Addresses tab, which is located under the My Profile tab on the Account Settings page."
    }]
  });
};